import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

function normalizeHashBookingTarget(hashValue) {
  const raw = String(hashValue || '').trim();
  if (!raw) return '';

  const hashBody = raw.startsWith('#') ? raw.slice(1) : raw;
  if (!hashBody) return '';

  const candidate = hashBody.startsWith('/') ? hashBody : `/${hashBody}`;
  return candidate.startsWith('/interview-booking') ? candidate : '';
}

export default function InterviewBookingHashRedirect() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const target = normalizeHashBookingTarget(location.hash);
    if (!target || target === `${location.pathname}${location.search}`) return;
    navigate(target, { replace: true });
  }, [location.hash, location.pathname, location.search, navigate]);

  return null;
}

